const componentName = 'screenshare';
const serviceName = 'PatientScreenshareRealtimeComponent';
const moduleName = 'doxy.realtime.components.patient-screenshare';
export { componentName, serviceName, moduleName };
import PatientScreenshareRealtimeComponent from './patient/screensharing';
import patientScreensharePopup from './patient/patient-screenshare-popup/patient-screenshare-popup';

export default angular
  .module(moduleName, [patientScreensharePopup])
  .service(serviceName, PatientScreenshareRealtimeComponent).name;
